export default {
  ticketList: {
    listDesc:
      "All tickets you have sent to Excoino support are listed on this page:",
    submitTicket: "Submit New Ticket",
    noMessages: "You have no messages",
    id: "ID",
    department: "Department",
    subject: "Subject",
    lastUpdate: "Last Update",
    status: "Status",
    previousTickets: ""
  },
  singleTicket: {
    closed: "Closed",
    closeTicket: "Close Ticket",
    viewMore: "View More",
    ticketIsClosed: "This ticket is closed",
    ticketWasClosed: "Ticket was closed",
    submitTicketIfHaveQuestion:
      "If you have any questions, please submit a new ticket",
    submitTicket: "Submit New Ticket",
    messagePlaceholder: "Message ...",
    doYouClose: "If you close the ticket, it means your question has been answered and no further follow-up is needed.",
    sureClose: "I'm sure, close the ticket",
    giveUp: "Cancel closing the ticket",
    notAValidFormat: "Invalid file format.",
    notAValidSize: "File size should be less than 4MB."
  },
  createTicket: {
    selectSubject:
      "Please select the desired subject to send a support request:",
    subject: "Subject",
    title: "Title",
    titleError: "Enter the ticket title",
    messagePlaceholder: "Describe your issue...",
    messageError: "Enter the ticket description",
    attachmentTitle: "Attach File (optional)",
    submit: "Submit",
    hintsTitle: "For better response, pay attention to the following:",
    supportNumber: "Support Phone:",
    supportEmail: "Support Email:",
    alerts: {
      alertDesc:
        "Note that Excoino will never ask for your passwords. Do not give your private wallet information to anyone."
    },
    attachment: {
      fileFormats: "Allowed file formats: jpg, jpeg, png",
      fileFormatIsNotCorrect: "Invalid file format.",
      moreThanMaxSize: "The attached file size should not exceed {count} MB.",
      lessThanMinSize: "Attached file size should not be less than {count} MB."
    }
  },
  conversation: {
    excoinoSupport: "Excoino Support"
  }
};
